import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { toast } from 'sonner';
import { MilaLogo } from '../components/MilaLogo';
import { Button } from '@/components/ui/button';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Enforce light mode on login page
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    root.classList.add('light');
    root.style.colorScheme = 'light';
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;
      navigate('/dashboard');
    } catch (error: any) {
      toast.error(error.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-[#FAF9F6] text-[#24211D] p-4 relative transition-colors font-sans">
      <div className="flex items-center justify-between w-full max-w-4xl mx-auto pt-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs font-semibold text-[#7C756B] hover:text-[#1E1B18] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>Volver a la tienda</span>
        </Link>
        <span className="text-[11px] font-medium text-[#7C756B]">Acceso Restringido</span>
      </div>

      <div className="w-full max-w-sm mx-auto space-y-6 my-auto">
        <div className="text-center">
          <div className="h-16 w-16 rounded-2xl bg-[#C2410C]/10 border border-[#C2410C]/20 flex items-center justify-center p-3 mx-auto mb-4 shadow-2xs">
            <MilaLogo tight className="h-full w-full text-[#C2410C]" color="#C2410C" />
          </div>
          <h1 className="text-2xl font-serif font-bold tracking-tight text-[#1E1B18]">
            Mila <span className="text-[#C2410C]">OS</span>
          </h1>
          <p className="mt-1 text-xs text-[#7C756B]">Panel de Gestión & Taller de Fabricación 3D</p>
        </div>

        <form
          onSubmit={handleLogin}
          className="space-y-5 bg-white p-7 rounded-2xl shadow-sm border border-[#E8E4DC]"
        >
          <div className="space-y-4">
            <div className="space-y-1.5">
              <label className="text-xs font-semibold text-[#1E1B18]">
                Correo Electrónico
              </label>
              <input
                type="email"
                required
                className="flex h-10 w-full rounded-xl border border-[#DCD6CA] bg-[#FAF9F6] px-3.5 py-2 text-sm text-[#1E1B18] placeholder:text-[#A8A196] focus:outline-none focus:ring-2 focus:ring-[#C2410C]/20 focus:border-[#C2410C] transition-all"
                placeholder="operador@miladesign.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="space-y-1.5">
              <label className="text-xs font-semibold text-[#1E1B18]">
                Contraseña
              </label>
              <input
                type="password"
                required
                className="flex h-10 w-full rounded-xl border border-[#DCD6CA] bg-[#FAF9F6] px-3.5 py-2 text-sm text-[#1E1B18] placeholder:text-[#A8A196] focus:outline-none focus:ring-2 focus:ring-[#C2410C]/20 focus:border-[#C2410C] transition-all"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#C2410C] hover:bg-[#A8380A] text-white font-semibold rounded-xl h-10 text-xs shadow-sm transition-all"
          >
            {loading ? 'Ingresando al taller...' : 'Ingresar al Panel'}
          </Button>
        </form>
      </div>

      <div className="text-center text-[11px] text-[#A8A196] pb-4">
        Mila OS &copy; {new Date().getFullYear()} • Sistema de Gestión de Producción
      </div>
    </div>
  );
}
